<template>
  <div
    class="page answer-history is-overlay"
  >
    <p class="answer-history-tip">
      {{ $t('continue_answer_tips', { n: answerNum() }) }}
    </p>
    <b-button
      type="is-primary"
      class="answer-btn"
      @click="continueAnswer"
    >
      {{ $t('continue_answer') }}
    </b-button>
    <b-button
      class="answer-btn"
      @click="restart"
    >
      {{ $t('restart') }}
    </b-button>
  </div>
</template>

<script>
// import { cloneDeep } from 'lodash-es';
import { copyObject } from '@/utils/helper';
import { mapState } from 'vuex';
import * as types from '@/stores/mutation-types';
import workers from '@/workers/';
import { getAnswerHistoryCount } from './answer/answer-utils';

export default {
  name: 'AnswerHistory',

  computed: {
    ...mapState(['answers', 'surveyData', 'configs']),
  },

  methods: {

    answerNum() {
      return getAnswerHistoryCount(this.answers);
    },

    continueAnswer() {
      this.startAnswer();
    },

    async restart() {
      this.$store.commit(types.SURVEY_RESET_STATE);
      const { displayRules, questions } = this.surveyData;
      if (displayRules) {
        workers.initRule(JSON.stringify({
          rules: displayRules,
          questions,
          answers: {},
        })).then((rules) => {
          const newSurveyData = copyObject(this.surveyData);
          newSurveyData.questions = rules.newQuestions;
          this.$store.commit(types.INIT_SURVEY_DATA, {
            data: newSurveyData,
            isInit: true,
            meta: { configs: this.configs },
          });
        });
      }

      this.startAnswer();
    },

    startAnswer() {
      const { query } = this.$route;
      this.$router.replace({ name: 'answer', query });
    },
  },
};
</script>

<style lang="scss" scoped>

  .answer-history{
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    background: #fff;
    padding: 0 75px / $px;

    &-tip{
      font-size:18px ;
    }

    .answer-btn{
      min-width: 90%;
      margin-top: $normalGap;
      margin-bottom: -$normalGap / 2;
      @include desktop {
        margin-top: 30px;
        min-width: 220px;
        font-size: 18px;
      }
      @include landscape {
        min-width: 220px;
        font-size: 18px;
      }
    }

  }

</style>
